import { Link } from "react-router-dom"
import { useEffect, useState } from "react";
import getStatus from "./getStatus";
import { dbService } from "fbase";
import { collection, query, orderBy, onSnapshot } from "firebase/firestore";
import Pagination from "./Pagenation";

function ProductsList(){
    const [productlist, setProductlist] = useState([]);
    const [fbProductlist, setFbProductlist] = useState([]);
    let productArr;
    useEffect(()=>{
        const q = query(collection(dbService, "productlist"), orderBy("createdTime", "desc"));
        onSnapshot(q, (snapshot) => {
            productArr = snapshot.docs.map((doc) => ({
                fbid: doc.id,
                ...doc.data()
            }));
            setFbProductlist(productArr)
            setProductlist(productArr)
        });
    }, [])

    const itemsPerPage = 12;
    const [currentPage, setCurrentPage] = useState(1);
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;

    const currentProductlist = productlist.slice(startIndex, endIndex);

    useEffect(() => {
        window.scrollTo({
            top: document.getElementById('products-heading').offsetTop,
            behavior: 'smooth'
        });
    }, [currentPage]);

    const today = new Date();

    const [select, setSelect] = useState("");

    const onChangeList = (e) => {
        setCurrentPage(1);
        setSelect(e.target.value);
    }

    useEffect(() => {
        const storedValue = localStorage.getItem('selectedValue');
        const storedPage = localStorage.getItem('currentPage');

        if (storedValue) {
            setSelect(storedValue);
        } else {
            setSelect('total'); // 기본 값 설정
        }

        if(storedPage) {
            setCurrentPage(storedPage);
        } else {
            setCurrentPage(1);
        }
    }, []);

    useEffect(() => {
        localStorage.setItem('selectedValue', select);
        localStorage.setItem('currentPage', currentPage);

        if(select === "small"){
            setProductlist(fbProductlist.filter(item => item.type === "기내용/소형"))
        } else if(select === "medium"){
            setProductlist(fbProductlist.filter(item => item.type === "화물용/중형"))
        } else if(select === "large"){
            setProductlist(fbProductlist.filter(item => item.type === "화물용/대형"))
        } else if(select === "mini"){
            setProductlist(fbProductlist.filter(item => item.type === "미니캐리어"))
        } else if(select === "total"){
            setProductlist(fbProductlist)
        } else if(select === "able"){
            setProductlist(fbProductlist.filter(item => !item.repair && !item.damage && new Date(item.return_date).getTime() < today.getTime()))
        } else if(select === "unable"){
            setProductlist(fbProductlist.filter(item => new Date(item.return_date).getTime() >= today.getTime()))
        } 
    }, [select, fbProductlist, currentPage])

    window.onbeforeunload = () => {
        localStorage.setItem('selectedValue', select);
        localStorage.setItem('currentPage', currentPage);
    };

    return (
        <section className="page-section bg-light" id="products">
            <div className="container">
                <div className="text-center">
                    <h2 className="section-heading text-uppercase" id="products-heading">products</h2>
                    <select onChange={onChangeList} className="listSelect">
                        <option value="total">전체보기({fbProductlist.length})</option>
                        <option value="small">기내용/소형/20인치({fbProductlist.filter(item => item.type === "기내용/소형").length})</option>
                        <option value="medium">화물용/중형/24인치({fbProductlist.filter(item => item.type === "화물용/중형").length})</option>
                        <option value="large">화물용/대형/28인치({fbProductlist.filter(item => item.type === "화물용/대형").length})</option>
                        <option value="able">대여가능만 보기({fbProductlist.filter(item => !item.repair && !item.damage && new Date(item.return_date).getTime() < today.getTime()).length})</option>
                        <option value="unable">대여중만 보기({fbProductlist.filter(item => new Date(item.return_date).getTime() >= today.getTime()).length})</option>
                        <option value="mini">미니캐리어/14인치({fbProductlist.filter(item => item.type === "미니캐리어").length})</option>
                    </select>
                    <h5>*현재 동작구와 성북구에서만 수령 가능합니다.</h5>
                    <div className="row">
                        {currentProductlist.map((product) => (
                            <div className="col-lg-3 col-sm-6 mb-4" key={product.fbid}>
                                <div className="product-item" id="product">
                                    <Link
                                        className="product-link"
                                        to={process.env.PUBLIC_URL + `/product-detail/${product.fbid}`}
                                    >
                                        <div className="product-hover">
                                            <div className="product-hover-content">
                                                <i className="fas fa-plus fa-3x"></i>
                                            </div>
                                        </div>
                                        <div className={getStatus(product.reserv_date, product.return_date, product.repair, product.damage)}>{getStatus(product.reserv_date, product.return_date, product.repair, product.damage)}</div>
                                        <img
                                            className="img-fluid"
                                            src={product.imgSrc[0]}
                                            alt={product.id.slice(0,4)}
                                            loading="lazy"
                                        />
                                    </Link>
                                    <Link
                                        className="product-link"
                                        to={process.env.PUBLIC_URL + `/product-detail/${product.fbid}`}
                                    >
                                        <div className="product-caption">
                                            <div className="product-caption-heading">No.{product.num}</div>
                                            <h5 className="productName">{product.name}</h5>
                                            <div className="product-caption-subheading text-muted">
                                                {product.type}/{product.size}인치
                                            </div>
                                        </div>  
                                    </Link>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <Pagination
                currentPage={currentPage}
                itemsPerPage={itemsPerPage}
                totalItems={productlist.length}
                onPageChange={setCurrentPage}
            />
        </section>
    )
}

export default ProductsList;